import React from 'react';
import Users from '@crehana/icons/dist/Users';
import Star from '@crehana/icons/dist/Star';

import type { CourseCardProps } from '../../types';

const Enrollments: React.FC<Partial<CourseCardProps>> = props => {
  const { enrollments, score, hideScore } = props;

  const showScore = !hideScore && !!score;
  const showEnrollments = typeof enrollments === 'number' && enrollments > 0;

  return (
    <div className="EnrollmentsComponent">
      {showEnrollments && (
        <div className="EnrollmentsComponent_Users absolute right-0 bottom-0 flex items-center p-12 text-white z-2">
          <Users size={16} ignoreColor className="fill-current min-w-16" />
          <p className="font-body4 ml-4 tw-font-semibold">{enrollments}</p>
        </div>
      )}

      {showScore && (
        <div className="EnrollmentsComponent_Score flex items-center absolute top-0 right-0 p-12 z-2">
          <Star
            size={16}
            ignoreColor
            className="fill-current text-yellow-main min-w-16 min-h-16"
          />
          <p className="font-body4 tw-font-semibold text-white pl-4">
            {(
              Math.ceil((score!.average === 0 ? 5 : score!.average) * 100) / 100
            ).toFixed(2)}
          </p>
        </div>
      )}
    </div>
  );
};

export default Enrollments;
